module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-inner-1800.a36995ad.svg";